// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Cnxo7","colBig":"styles_colBig__b2rnn","colSmall":"styles_colSmall__1uikr","shopifyNameWrapper":"styles_shopifyNameWrapper__2GSIb"};